import React, { useState, useEffect } from "react";
import {
  Space,
  DatePicker,
  Checkbox,
  Button
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { TrainingAPI } from "../../api/TrainingAPI";
import moment from "moment";
import { 
  PermissionedDatePicker, 
  PermissionedCheckbox, 
  PermissionedButton, 
  PermissionedCheckboxGroup 
} from "../PermissionedComponents";
import PermissionViewable from "../PermissionedComponents/PermissionViewable";

const options = [
    { label: 'GPS', value: 'gps' },
    { label: 'Wellness', value: 'wellness' },
    { label: 'Testing', value: 'testing' },
    { label: 'Forceplate', value: 'forceplate' },
    { label: 'Nutrition', value: 'nutrition' }
  ];

const { RangePicker } = DatePicker;

export const DeleteData = () => {
  const date_format = "YYYY-MM-DD";

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [checkboxStatuses, setCheckboxStatuses] = useState({
    gps: { checked: false, disabled: true },
    wellness: { checked: false, disabled: true },
    testing: { checked: false, disabled: true },
    forceplate: { checked: false, disabled: true },
    nutrition: { checked: false, disabled: true }
  });
  const [loading, setLoading] = useState(false);

  const trainingAPI = new TrainingAPI();

  const onCheckboxChange = (checkedValues) => {
    setSelectedOptions(checkedValues);
  };

  const onDateChange = (value, dateString) => {
    setStartDate(dateString[0] === "" ? null : dateString[0]);
    setEndDate(dateString[1] === "" ? null : dateString[1]);
  };

  useEffect(() => {
    if (startDate && endDate){
        getDataTypesForDate(startDate, endDate)
    }
  }, [startDate, endDate]);


  const getDataTypesForDate = async (startDate, endDate) => {
    const newStatuses = {
      gps: { checked: false, disabled: true },
      wellness: { checked: false, disabled: true },
      testing: { checked: false, disabled: true },
      forceplate: { checked: false, disabled: true },
      nutrition: { checked: false, disabled: true }

    }

    try {
      const resp = await trainingAPI.getDataDeletionTypesForDate(
        {
          startDate: moment(startDate).format(date_format),
          endDate: moment(endDate).format(date_format)
        })

        newStatuses.gps.disabled = !resp.gps;
        newStatuses.wellness.disabled = !resp.wellness;
        newStatuses.testing.disabled = !resp.testing;
        newStatuses.forceplate.disabled = !resp.forceplate;
        newStatuses.nutrition.disabled = !resp.nutrition;

        setCheckboxStatuses(newStatuses)
        setSelectedOptions([]);
    } catch (err) {
      console.log(err);
      message.error("Error identifying data types for the given date");

      setCheckboxStatuses(newStatuses)
      setSelectedOptions([]);
    }
  }


  const onSubmit = async () => {
    setLoading(true)
    
    const payload = {
        startDate: moment(startDate).format(date_format),
        endDate: moment(endDate).format(date_format),
        datatypes: selectedOptions
    }

    try {
      await trainingAPI.deleteDataForDate(payload)
      message.success("Data Deleted Succesfully");
    } catch (err) {
      console.log(err);
      if (err.status == 400){
          message.error(err.data)
      } else {
          message.error("Error deleting data")
      }
    }

    setLoading(false)    
  };

 
  return (
    <PermissionViewable 
      permissionCheck="DeleteDatapoints"
      permissionMessage="You don't have permission to delete data"
      tooltipMessage="Data deletion requires special permissions"
    >
      <div className="report-injury-header2">Pick a date to get started.</div>
      <br />
      <Space>
        <div className="injury-item">
          <PermissionedDatePicker.RangePicker
              onChange={onDateChange}
              value={[
                startDate !== null
                  ? moment(startDate, date_format)
                  : null,
                  endDate !== null
                  ? moment(endDate, date_format)
                  : null,
              ]}
              style={{ width: 250 }}
              permissionCheck="DeleteDatapoints"
            />
        </div>
        </Space>
        <br />
        <br />
        <div className="injury-item">
            <PermissionedCheckboxGroup
                value={selectedOptions}
                onChange={onCheckboxChange}
                style={{ marginTop: '16px', display: 'block' }}
                permissionCheck="DeleteDatapoints"
            >
                {options.map(option => (
                <PermissionedCheckbox
                    key={option.value}
                    value={option.value}
                    checked={checkboxStatuses[option.value].checked}
                    disabled={checkboxStatuses[option.value].disabled}
                    permissionCheck="DeleteDatapoints"
                >
                    {option.label}
                </PermissionedCheckbox>
                ))}
            </PermissionedCheckboxGroup>
        </div>
        <br />
        <div className="injury-item">
        <PermissionedButton 
            loading={loading}
            type={"primary"}
            onClick={onSubmit}
            disabled={selectedOptions.length === 0}
            permissionCheck="DeleteDatapoints"
        > Delete </PermissionedButton>
        </div>
        
    </PermissionViewable>
  );
};
